// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"22":"help","639":"categories","920":"devices","945":"dashboard"}[chunkId] + "." + {"22":"55f28f46","639":"6c791f12","920":"09692ad0","945":"2bac7bcb"}[chunkId] + ".css";
};